/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const interventiAPI = {
  list: async (params = {}) => {
    const { data } = await apiClient.get('/interventi', { params });
    return data;
  },
  stati: async () => {
    const { data } = await apiClient.get('/interventi/stati');
    return data;
  },
  detail: async (id) => {
    const { data } = await apiClient.get(`/interventi/${id}`);
    return data;
  },
  create: async (intervento) => {
    const { data } = await apiClient.post('/interventi', intervento);
    return data;
  },
};
